import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MenuItem } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-download-btn",
  templateUrl: "./download-btn.component.html",
  styleUrls: ["./download-btn.component.scss"],
})
export class DownloadBtnComponent implements OnInit {
  @Output() actionBtnCallback = new EventEmitter<any>();
  @Output() downloadExcel = new EventEmitter<any>();
  @Output() downloadChart = new EventEmitter<any>();
  @Input() showLoader?: boolean = false;
  @Input() padding: string = "10px";
  @Input() btnClassName: string = "";
  @Input() iconColor: string = "#000";
  @Input() menuItems: MenuItem[] = [];
  @Input() triggerMenu?: boolean = false;
  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.buildMenuItems();
    this.translate.onLangChange.subscribe(() => this.buildMenuItems());
  }

  private buildMenuItems(): void {
    this.menuItems = [
      {
        label: this.translate.instant("SHARED.IMAGE"),
        command: (event) => {
          this.triggerChartDownload(event);
        },
      },
      {
        label: this.translate.instant("SHARED.EXCEL"),
        command: (event) => {
          this.triggerExcelDownload(event);
        },
      },
    ];
  }

  btnAction(event: any) {
    this.actionBtnCallback.emit(event);
  }

  triggerExcelDownload(event: any) {
    this.downloadExcel.emit(event);
  }
  triggerChartDownload(event: any) {
    this.downloadChart.emit(event);
  }
}
